import { StyledCustomCheckbox } from 'components/custom-checkbox/custom-checkbox.styles';
import styled from 'styled-components';

export const MultiSelectCheckbox = styled(StyledCustomCheckbox)`
  padding: 2px 5px;
  margin: 0;
`;
